import type { BlockComponentProps } from "./shared"

export function BlockquoteBlock({ content, resolved }: BlockComponentProps) {
  const bq = (content?.quote as string) ?? ""
  const attr = (content?.attribution as string) ?? ""
  const src = (content?.source as string) ?? ""
  if (!bq) return null
  const bqSectionClass = resolved.hasOverrides
    ? `px-4 @sm:px-6 @md:px-8 ${resolved.paddingClass || "py-6"} ${resolved.cornerClass} ${resolved.alignClass} max-w-2xl mx-auto`.trim()
    : "px-4 py-6 @sm:px-6 @md:px-8 max-w-2xl mx-auto"
  return (
    <section className={bqSectionClass} style={resolved.sectionStyle}>
      <blockquote className="border-l-4 pl-6 italic text-lg" style={{ borderColor: "var(--nos-color-primary, #3b82f6)" }}>
        &quot;{bq}&quot;
        {attr && <footer className="mt-2 not-italic text-sm text-muted-foreground">— {attr}</footer>}
        {src && <cite className="block text-xs text-muted-foreground mt-1">{src}</cite>}
      </blockquote>
    </section>
  )
}
